import React from 'react'
import './WelcomeDoc.css'

const WelcomeDoctor = () => {
  return (
    <div className='welcome-section'>
       <h1>Welcome to the Team, Doctor 🧑‍⚕️</h1>
       <p>Thank You for choosing us and cooperating with us. We all are greatful for your services.
            Thank you for working 24*7 to save our lives.</p>
       <br />
       <h5>Let's fill some details before moving on to the next step</h5>
    </div>
  )
}

export default WelcomeDoctor